import { render, staticRenderFns } from "./Renewing.vue?vue&type=template&id=fdede250&scoped=true&"
import script from "./Renewing.vue?vue&type=script&lang=js&"
export * from "./Renewing.vue?vue&type=script&lang=js&"
import style0 from "./Renewing.vue?vue&type=style&index=0&id=fdede250&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdede250",
  null
  
)

export default component.exports